module.exports = __webpack_public_path__ + "static/media/PaulMedi.01e2835d.jpg";